// extracted by mini-css-extract-plugin
export default {"exportError":"GolfCoursesPage_exportError__J-UjQ","holesBadge":"GolfCoursesPage_holesBadge__SJiCl"};